<template>
    <div>
        <div class="card card--venue card--venue_large">
            {{ startEndDates }}
            <div v-if="post.event.venue">
                <h2>{{ post.event.venue }}</h2>
                <img width="100%" :src="'https://maps.googleapis.com/maps/api/staticmap?autoscale=2&scale=2&size=860x200&maptype=roadmap&key=AIzaSyCjz3LIQwN2Ip1jfll0zUrIAvDfTW7A9-4&format=png&visual_refresh=true&zoom=13&markers=size:small%7Ccolor:0xff0000%7Clabel:1%7C' + encodeURI(post.event.venue)">
            </div>
        </div>
        <a :href="getDownloadUrl" target="_blank" class="btn btn-small">Add to calendar</a>
    </div>
</template>

<script>
    import { format, formatDistance, subDays, parse } from 'date-fns';
    export default {
        props: ['post'],
        data(){
            return {

            }
        },
        created() {

        },
        computed: {
            startEndDates: function(){
                var starts = parse(this.post.event.starts, 'yyyy-MM-dd HH:mm:ss', new Date());
                var ends = parse(this.post.event.ends, 'yyyy-MM-dd HH:mm:ss', new Date());

                if(starts.getDate() === ends.getDate() && starts.getMonth() === ends.getMonth()&& starts.getYear() === ends.getYear()){
                    return format(starts, 'E do LLL yyyy h:mma - ') + " " + format(ends, 'h:mma');
                }else{
                    return format(starts, 'E do LLL yyyy h:mma - ') + " " + format(ends, 'E do LLL yyyy h:mma');
                }
            },
            getDownloadUrl: function() {
                return '/groups/'+ this.post.group.slug + '/' + this.post.slug + '/download-ics';
            }
        },
        methods: {
        }
    }
</script>

<style lang="scss">
</style>
